import api from "..";

export const updateHierarchy = (id, data, callBack) => {
    api.put(`/companies/${id}/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};





